/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { FormikProps } from 'formik';
import { Dispatch, SetStateAction } from 'react';

import { Organization } from '../../../types/organization/Organization';
import {
  ApiValidationGetFieldError,
  ApiValidationHasFieldError,
  ApiValidationResetFieldError,
} from '../../../utils/useApiValidation';
import { CreateProjectFormValues } from '../../CreateProjectOverlay/CreateProjectOverlay.types';

export enum FormType {
  PROJECT = 'PROJECT',
}

export type TExtendedFormKeys = keyof CreateProjectFormValues;

export type TExtendedFormValues = Record<TExtendedFormKeys, unknown>;

export type TCommonCreateContainer = {
  type: FormType.PROJECT;
  formProps: FormikProps<CreateProjectFormValues>;
} & {
  errorMessage?: string;
  isFetchingOrganizations: boolean;
  resetApiError: ApiValidationResetFieldError;
  hasFieldApiError: ApiValidationHasFieldError;
  getFieldApiError: ApiValidationGetFieldError;
};

export type TCommonCreateForm = Omit<TCommonCreateContainer, 'errorMessage' | 'resetApiError'> & {
  type: FormType;
  pickedState: TState;
  setPickedState: Dispatch<SetStateAction<TState>>;
};

export type TPickerModal = Omit<TCommonCreateForm, 'formProps' | 'hasFieldApiError' | 'getFieldApiError'> & {
  values: TExtendedFormValues;
  setValues: (values: CreateProjectFormValues) => void;
  organizations?: Organization[];
};

export type TState = {
  organization?: Organization;
};
